/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionOption } from './questionOption';

export type ContentStudioQuestionOptions = QuestionOption[] | null;
